import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { HTMLParser, PageTitle } from 'containers';
import { FiltersBar, Download, DatePicker, ControlWrapper } from 'components';

import { useStyles } from './style';

interface Props {
  fileName: string;
  date: Date | null;
  url: string | null;
  handleChangeDate: (date: Date | null, name?: string) => void;
}

const InvestorTenantsDetails: React.FC<Props> = ({
  fileName,
  date,
  url,
  handleChangeDate,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <PageTitle />
      <FiltersBar className={classes.filtersBar}>
        <ControlWrapper>
          <span className={classes.label}>
            {t('#portal.investor.report.tenant.date')}:
          </span>
          <DatePicker date={date} handleChange={handleChangeDate} />
        </ControlWrapper>
        <ControlWrapper>
          <Download name={fileName} url={`${url}&download=true`} />
        </ControlWrapper>
      </FiltersBar>
      {url ? <HTMLParser url={url} /> : null}
    </>
  );
};

export default memo(InvestorTenantsDetails);
